const gtmTracking = () => {
  const triggerLabel = 'data-gtm-trigger'
  const triggerLabelClick = `[${triggerLabel}="click"]`
  const triggerElements = document.querySelectorAll(triggerLabelClick)

  // Handle click tracking
  triggerElements.forEach((item) => {
    item.addEventListener('click', (e) => {
      const data = e.currentTarget.dataset
      if (!data || !data.gtmTracking) {
        return
      }
      window.dataLayer.push(JSON.parse(data.gtmTracking))
    })
  })

  // Handle visibility tracking for #instructions
  const instructionBlock = document.querySelector('#instructions')
  let visibilityTimeout = null
  const firedEvents = new Set()

  if (instructionBlock) {
    const handleVisibility = (entries) => {
      const [entry] = entries
      if (entry.isIntersecting && !firedEvents.has('viewRecipeInstructions10s')) {
        visibilityTimeout = setTimeout(() => {
          if (!firedEvents.has('viewRecipeInstructions10s')) {
            window.dataLayer.push({
              event: 'viewRecipeInstructions10s'
            })
            firedEvents.add('viewRecipeInstructions10s')
          }
        }, 10000)
      } else if (visibilityTimeout) {
        clearTimeout(visibilityTimeout)
      }
    }

    const observer = new IntersectionObserver(handleVisibility, {
      threshold: 0.5
    })

    observer.observe(instructionBlock)
  }

  const linkedRecipes = document.querySelectorAll('.step-linked-recipe')
  linkedRecipes.forEach((link) => {
    link.addEventListener('click', () => {
      const recipeHeading = link.querySelector('h4')
      const linkedRecipeName = recipeHeading ? recipeHeading.innerText.trim() : ''
      window.dataLayer.push({
        event: 'recipeStepRelatedRecipe',
        linkedRecipe: linkedRecipeName
      })
    })
  })

  const minusBtn = document.querySelector(
    'button[data-gtm-trigger="click"][data-action="decrease"]'
  )
  const plusBtn = document.querySelector(
    'button[data-gtm-trigger="click"][data-action="increase"]'
  )
  const portionsLabel = document.querySelector('.amount-of-portions')

  if (!portionsLabel) {
    return
  }

  const sendEvent = (type) => {
    const portions = portionsLabel.textContent.trim()
    window.dataLayer.push({
      event: 'portionsField',
      type,
      portions,
      placement: 'recipe ingredients'
    })
  }

  if (minusBtn) minusBtn.addEventListener('click', () => sendEvent('subtract'))
  if (plusBtn) plusBtn.addEventListener('click', () => sendEvent('add'))
}

export default gtmTracking
